import { styled, TextField } from '@mui/material';

export interface FormTextFieldStyledProps {
  solid?: boolean;
}

export const FormTextFieldStyled = styled(TextField)<FormTextFieldStyledProps>(
  ({ theme, solid }) => ({
    '& .FormTextField-clear': {
      // display: 'none',
    },

    '.h3-optional-required': {
      color: theme.palette.text.secondary,
    },

    '&:hover': {
      '& .FormTextField-clear': {
        display: 'inline-flex',

        '& ~ .FormTextField-dropdown': {
          display: 'none',
        },
      },

      '& .FormTextField-dropdown': {
        color: theme.palette.text.primary,
      },
    },

    '& .MuiOutlinedInput-root.MuiAutocomplete-inputRoot [aria-expanded="true"]': {
      '& ~ .MuiInputAdornment-root': {
        '& .FormTextField-clear': {
          display: 'inline-flex',

          '& ~ .FormTextField-dropdown': {
            display: 'none',
          },
        },

        '& .FormTextField-dropdown': {
          transform: 'rotate(180deg)',
          color: theme.palette.text.primary,
        },
      },

      '& ~ .MuiOutlinedInput-notchedOutline': {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      },
    },

    ...(solid && {
      '& .MuiOutlinedInput-input': {
        zIndex: 1,
      },

      '& .MuiInputAdornment-root': {
        zIndex: 1,
      },

      '& .MuiOutlinedInput-notchedOutline': {
        backgroundColor: theme.palette.background.paper,
      },
    }),
  }),
);
